import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    userName: string;
}

export default function DeleteUserDialog(props: Props) {
    const handleConfirm = () => {
        props.onConfirm();
        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Really delete this user?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Delete {props.userName}? This action cannot be undone and will permanently remove the user and all their permissions.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
